import { Stack, Typography } from "@mui/material";
import TooltipForDisabledAction from "@entrilia/shared/components/TooltipForDisabledAction";
import BorderedRadioLabel from "../../../../common/BorderedRadioLabel";

type PublishDateOption = "make_live" | "custom";

interface Props {
  value: PublishDateOption;
  selectedValue: PublishDateOption;
  title: string;
  description: string;
  disabled?: boolean;
  disabledTooltip?: string;
}

const InvestorCommunicationPublishDateOption = ({
  value,
  selectedValue,
  title,
  description,
  disabled,
  disabledTooltip,
}: Props) => (
  <BorderedRadioLabel<PublishDateOption>
    value={value}
    selectedValue={selectedValue}
    disabled={disabled}
    label={
      <TooltipForDisabledAction title={disabledTooltip} isActionDisabled={disabled}>
        <Stack spacing={0.5}>
          <Typography variant="subtitle2">{title}</Typography>
          <Typography variant="caption" color={disabled ? "textDisabled" : "textSecondary"}>
            {description}
          </Typography>
        </Stack>
      </TooltipForDisabledAction>
    }
    sx={{ pl: 1.5, py: 1.5 }}
  />
);

export default InvestorCommunicationPublishDateOption;
